import React from 'react'
import {connect} from 'react-redux'
import Titulo from '../comum/Titulo';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import buscarPrestadores from '../../actions/prestador/buscarPrestadores';
import excluirPrestador from '../../actions/prestador/excluirPrestador';
import selecionarPrestador from '../../actions/prestador/selecionarPrestador';
import PaginacaoPrestador from './PaginacaoPrestador';
import BotoesPaginacaoPrestador from './BotoesPaginacaoPrestador';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PainelFiltragem from './PainelFiltrosPrestador';
import Prestador from './Prestador';
import ModalCadastrarPrestador from './ModalCadastrarPrestador';
import {showSuccessMsg} from '../../util/messagesUtil';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-tabela-dados">
        <div className="row cabecalho-desktop">
            <div className="col">Número</div>
            <div className="col">Nome</div>
            <div className="col">Responsável</div>
            <div className="col">CPF/CNPJ</div>
            <div className="col">Telefone</div>
            <div className="col">Localidade</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

const ModalConfirmacaoExclusao = ({excluir, prestador}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoPrestador" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir o prestador <strong>{prestador ? prestador.nome : ''}?</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarPrestadores extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parametros: {
                nome: '',
                uf: ''
            }
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.buscarPrestadores();
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps) || this.props.empresaSelecionada !== prevProps.empresaSelecionada) {
            this.buscarPrestadores();
        }
    }

    buscarPrestadores() {
        this.props.buscarPrestadores(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    exibirBotaoNovoPrestador() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="text-right">
                        <button data-toggle="modal" data-target="#modalCadastrarPrestador" className="btn btn-laranja"
                                onClick={() => this.props.selecionarPrestador()}>
                            Novo Prestador
                        </button>
                    </div>
                </div>
            </div>)
    }

    exibir() {
        if (this.props.prestadores && this.props.prestadores.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoPrestador}
                                       BotoesPaginacao={BotoesPaginacaoPrestador}>
                    <div className="col-12 conteudo-internas">
                        <CabecalhoTabela/>
                        <div className="lista-table">
                            {this.exibirPrestadores()}
                        </div>
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhum prestador encontrado para os parâmetros informados.</div>;
    }

    exibirPrestadores() {
        if (this.props.prestadores) {
            return this.props.prestadores.map(prestador => <Prestador key={prestador.id}
                                                                      prestador={prestador}
                                                                      idEmpresa={this.props.empresaSelecionada.id}/>)
        }
    }

    excluir() {
        this.props.excluirPrestador(this.props.prestadorSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Prestador excluído com sucesso');
                this.buscarPrestadores();
            })
    }

    exibirFiltro() {
        return <div className="row">
            <div className="col-md-12">
                <div className="text-right">
                    <PainelFiltragem/>
                </div>
            </div>
        </div>
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Prestador Empresa" urlRetorno="/menu-itinerario"/>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            {this.exibirFiltro()}
                            {this.exibirBotaoNovoPrestador()}
                            <div className="lista-table">
                                {this.exibir()}
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCadastrarPrestador parametros={this.state.parametros}
                                       buscarPrestadores={this.buscarPrestadores.bind(this)}/>
                <ModalConfirmacaoExclusao excluir={this.excluir.bind(this)} prestador={this.props.prestadorSelecionado}/>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => (
    {
        prestadores: state.prestadores.prestadores,
        prestadorSelecionado: state.prestadores.prestadorSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualPrestador,
        registrosPorPagina: state.registrosPorPaginaPrestador,
        filtrosAdicionados: state.filtrosAdicionadosPrestador

    });


export default connect(mapStateToProps, {
    buscarPrestadores,
    excluirPrestador,
    selecionarPrestador
})(PainelGerenciarPrestadores)
